export default "__VITE_ASSET__B$TliLfU__"